<template>
  <div class="">
    <div class="navbar">
      <div class="navbar-brand">
        <img v-if="showLogo" class="partner-logo" :src="showLogo" />
        <img v-else class="bkps-logo-dashboard" src="@/assets/images/logo-brobot-azul@250x50.png" />
      </div>

      <div class="buttons mr-2">
        <i v-if="!getPartner" @click="toggleTheme" class="icon mr-4"
          :title="isDarkTheme ? 'Alternar para tema claro' : 'Alternar para tema escuro'">
          <sun-icon v-if="isDarkTheme" />
          <moon-icon v-else />
        </i>

        <i @click="showNotification = !showNotification; markAllRead()" class="icon mr-4">
          <bell-icon />
          <small v-if="unreadNotification > 0" class="notification-amount">{{ unreadNotification }}</small>
        </i>

        <span style="position: relative">
          <Popup v-model="showNotification" :start-with="-35" with-animation="fast" :width="350"
            @closePopup="showInnerNotification = false" @startOpenPopup="showInnerNotification = true">
            <div class="notifications">
              <template v-if="showInnerNotification">
                <div class="notifications-header">
                  <span :class="{ selected: show === 'notification' }"
                    @click="show = 'notification'">Notificações</span>
                  <span :class="{ selected: show === 'process' }" @click="show = 'process'">Processamento</span>
                </div>

                <div class="notifications-content">

                  <Notification v-if="show === 'notification'" @unreadNotification="unreadNotification = $event" />

                  <Process v-else-if="show === 'process'" />

                </div>

                <div v-if="show === 'notification'" class="notifications-foot">
                  <span @click="sendNotifications" class="btn btn-primary">Ver todas as notificações</span>
                </div>
              </template>
            </div>
          </Popup>
        </span>

        <User />

      </div>

    </div>

    <div v-if="isPretender" @click="stopImpersonating()" class="pretender" title="Voltar para seu usuário">
      <p :title="`Super User: ${pretender}`">
        <span class="mr-2">Você está logado como: {{ getUser.name }} [{{ getUser.email }}]</span>
        <span class="mr-2">-</span>
        <strong class="mr-2">Clique na linha para parar</strong>
        <MehIcon />
      </p>
    </div>
  </div>
</template>

<script>
import User from '../shares/User'
import { BellIcon, MehIcon, SunIcon, MoonIcon } from 'vue-feather-icons'
import GetUser from '@/mixins/GetUser'
import { notifySessionChanged } from '@/utils/sessionChannel'
import GetAccount from '@/mixins/GetAccount'
import GetPartner from '@/mixins/GetPartner'

import Notification from '@/components/dashboard/header/Notification'
import Process from '@/components/dashboard/header/Process'
import Popup from '@/components/shares/Popup'

const expiredIn = 1 // 1 minute
const setIntervalFrequency = process.env.VUE_APP_ENV === 'development' ? (5 * 60 * 1000) : (60 * 1000) // 5|1 minutes

export default {
  beforeDestroy() {
    clearInterval(this[this.$name() + 'NotificationSetInterval'])
  },
  components: { BellIcon, MehIcon, SunIcon, MoonIcon, Notification, Popup, Process, User },
  computed: {
    isPretender() {
      return this.pretender
    },
    showNotificationFooter() {
      return this.showNotification && this.$route.path !== '/definitions'
    },
    showLogo() {
      return this.getAccount.logo_url || this.getPartner?.logo_url
    },
    isDarkTheme() {
      return this.$store.getters.isDarkTheme
    }
  },
  created() {
    this.pretender = this.getUser.pretender

    this.getUnreadNotification()
    this[this.$name() + 'NotificationSetInterval'] = setInterval(() => {
      this.getUnreadNotification()
    }, setIntervalFrequency)
  },
  data() {
    return {
      pretender: null,
      show: 'notification',
      showHelp: false,
      showInnerNotification: false,
      showNotification: false,
      // 'process',
      unreadNotification: 0
    }
  },
  methods: {
    getUnreadNotification() {
      if (document.hidden)
        return

      const unreadNotification = this.$ls.get('unreadNotification')
      if (unreadNotification || unreadNotification === 0)
        return this.unreadNotification = unreadNotification

      this.axios.get('notifications?meta=true&q[read]=false')
        .then(response => response.meta)
        .then(meta => this.unreadNotification = meta.total_count || 0)
        .then(() => this.$ls.set('unreadNotification', unreadNotification || 0, { minutes: expiredIn }))
    },
    markAllRead() {
      if (this.unreadNotification === 0)
        return

      this.axios.put('/notifications/mark_all_read')
        .then(() => this.unreadNotification = 0)
    },
    sendNotifications() {
      const tabNotification = document.getElementById('tab-notifications')
      if (tabNotification)
        tabNotification.click()
      else
        this.$router.push('/definitions?tab=notifications').catch(() => { })

      this.showNotification = false
    },
    stopImpersonating() {
      this.$ls.clear()
      this.axios.post('admin/users/stop_impersonating')
        .then(() => {
          notifySessionChanged()
          location.href = '/'
        })
    },
    toggleTheme() {
      this.$store.commit('toggleTheme')
    }
  },
  mixins: [GetUser, GetAccount, GetPartner],
  mounted() {
    this.popupItem = this.$el
  },
  name: 'Header'
}
</script>

<style>
.pretender {
  background-color: #ecd28e;
  border-radius: 8px;
  height: 32px;
  display: flex;
  border: solid 1px black;
  justify-content: center;
  margin: 0 20px;
  cursor: pointer;

  animation: attention 15s linear infinite
}

@keyframes attention {
  25% {
    background-color: orange;
    margin: 0 10px;
  }

  50% {
    font-size: large;
    background-color: red;
  }

  75% {
    background-color: orange;
    margin: 0 10px;
  }
}

.row2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  margin: 0 15px;
}

.buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.buttons svg {
  cursor: pointer;
}

.buttons span {
  position: relative;
}

.notifications {
  /*position: absolute;*/
  width: 350px;
  height: 518px;
  left: -150px;
  top: 50px;
  border-radius: 5px;
  background: var(--background-color);
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.23);

  display: flex;
  flex-direction: column;
}

.notifications-header {
  height: 58px;
  background-color: var(--white-bg);
  border-radius: 5px 5px 0 0;
  display: flex;
}

.notifications>div>span {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.notifications>div>span:hover {
  font-weight: 700;
}

.notifications-header span.selected {
  border-bottom: 3px solid #318BE3;
  font-weight: bold;
}

.notifications-content {
  border-radius: 0 0 5px 5px;
  overflow-y: auto;
  height: 100%;
  -ms-overflow-style: none;
  /* Internet Explorer 10+ */
  scrollbar-width: none;
  /* Firefox */
}

.notifications-content::-webkit-scrollbar {
  display: none;
  /* Safari and Chrome */
}

.notifications-item {
  width: 326px;
  /* altura livre para a mensagem aparecer por completo. #85216 */
  min-height: 112px;

  background: var(--white-bg);
  border: 1px solid var(--border-color);
  box-sizing: border-box;
  border-radius: 5px;

  padding: 14px 12px;
  margin: 5px 12px;
}

.notifications-item-date {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: var(--terciary-text-color);
}

.notifications-item-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;

  color: var(--primary-text-color);
}

.notifications-item-content {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;

  color: var(--terciary-text-color);
}

.notifications-foot {
  width: 326px;
  height: 40px;

  margin: 7px 12px;
}

i.icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

i.icon:hover {
  opacity: 0.7;
}

.notification-amount {
  background-color: #fa3e3e;
  border-radius: 10px;
  color: #fff;
  width: 17px;
  height: 17px;
  padding: 2px 2px;
  display: flex;
  justify-content: center;
  align-content: center;
  position: absolute;
  left: 16px;
  top: -8px;
  font-size: 11px;
}

.header-help {
  background: #EDF0F5;
  margin: 8px;
  padding: 8px;
}
</style>
